import React from 'react';
import MenuItemComponent from './MenuItem';
import { SidebarMenuProps } from '../types';

const SidebarMenu: React.FC<SidebarMenuProps> = ({ sortedItems, openKeys, selectedKeys, handleMenuAction }) => {
  return (
    <div className="flex h-5/6 w-auto overflow-y-scroll hide-scrollbar mb-2 mt-2">
      <ul className="w-full">
        {sortedItems.map((item) => (
          <MenuItemComponent
            key={item.key}
            item={item}
            depth={0}
            keyPath={[item.key]}
            openKeys={openKeys}
            selectedKeys={selectedKeys}
            handleMenuAction={handleMenuAction}
          />
        ))}
      </ul>
    </div>
  );
};

export default SidebarMenu;
